import { Camera, Calculator, Ruler, Wrench, ArrowRight } from "lucide-react";

const steps = [
  {
    icon: Camera,
    n: "01",
    title: "Stuur foto's & afmetingen",
    text:
      "Bezorg ons foto's van het glas, raam of de ruimte. Een schatting van de afmetingen is genoeg voor een eerste richtprijs.",
  },
  {
    icon: Calculator,
    n: "02",
    title: "Ontvang een richtprijs",
    text:
      "We maken een duidelijke prijsinschatting op basis van je toepassing, afmetingen en gewenste oplossing.",
  },
  {
    icon: Ruler,
    n: "03",
    title: "Opmeting & advies",
    text:
      "We bekijken de technische haalbaarheid, het type glas en de beste manier van plaatsing.",
  },
  {
    icon: Wrench,
    n: "04",
    title: "Levering & installatie",
    text:
      "Na akkoord zorgen we voor levering en een strakke, professionele plaatsing.",
  },
];

export default function HowItWorks() {
  const scrollToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="hoe-werkt-het"
      className="relative py-24 md:py-32 bg-black/30"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
            Het proces
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight">
            Hoe werkt het?
          </h2>
          <p className="mt-5 text-base md:text-lg text-zinc-400 font-body max-w-2xl">
            Van eerste foto tot strakke installatie: we maken het proces
            eenvoudig en duidelijk.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                className="jn-glass jn-card-hover rounded-3xl p-7 relative overflow-hidden"
                data-testid={`step-${i + 1}`}
              >
                <div
                  className="absolute right-5 top-5 font-heading text-5xl font-light"
                  style={{ color: "rgba(0,229,255,0.15)" }}
                >
                  {s.n}
                </div>
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center mb-5 border border-cyan-400/30"
                  style={{ background: "rgba(0,229,255,0.08)" }}
                >
                  <Icon size={20} className="text-cyan-400" />
                </div>
                <h3 className="font-heading text-xl text-white font-medium tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 font-body leading-relaxed">
                  {s.text}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            onClick={scrollToForm}
            className="jn-btn-primary inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm md:text-base"
            data-testid="how-it-works-cta"
          >
            Vraag je richtprijs aan
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
